import { useAppSelector } from "app/hooks";
import { useState } from "react";
import { shallowEqual } from "react-redux";
import { selectRosterOrgDetails } from "selectors/Roster";
import { SelectableLogo, LogoContainer } from "./styles";

interface Props {
  rosterId: string;
  tournamentId: string;
  selected: boolean;
  title?: string;
}

// todo - not sure this is needed, can control the styling where used like most other 'Selectable' OrgLogos do I think
export const SelectableRosterOrgLogo = ({
  rosterId,
  tournamentId,
  selected,
  title,
}: Props) => {
  const { id: orgId, name } =
    useAppSelector(
      (state) => selectRosterOrgDetails(state, rosterId, tournamentId),
      shallowEqual
    ) || {};

  const [imgSrc, setImgSrc] = useState(
    !!orgId ? `/images/orgs/${orgId}/logo.png` : "/images/orgs/default/logo.png"
  );

  return (
    <LogoContainer>
      <SelectableLogo
        src={imgSrc}
        selected={selected}
        title={title ?? name}
        onError={() => setImgSrc(`/images/orgs/default/logo.png`)}
      />
    </LogoContainer>
  );
};
